<script>import Children from "../Children.svelte";
export let tagName;
export let children;
export let properties;
export let type = void 0;
export let position = void 0;
export let __index = void 0;
type && position && __index;
</script>

{#if Array.isArray(children) && children.length !== 0}
	<!-- prettier-ignore -->
	<svelte:element this={tagName} {...properties}><Children {children} /></svelte:element>
{:else}
	<!-- prettier-ignore -->
	<svelte:element this={tagName} {...properties} />
{/if}
